import { render, staticRenderFns } from "./DetailBullionWithdrawal.vue?vue&type=template&id=258313ce&scoped=true&"
import script from "./DetailBullionWithdrawal.vue?vue&type=script&lang=js&"
export * from "./DetailBullionWithdrawal.vue?vue&type=script&lang=js&"
import style0 from "./DetailBullionWithdrawal.vue?vue&type=style&index=0&id=258313ce&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "258313ce",
  null
  
)

export default component.exports